// Keep these platform lists in sync with @dialogueconsulting/sked-preview.
export const allowedSelectCoverPlatforms = ["IG", "FB", "LI", "TT"] as const;
